import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';

export interface TrackModalImpression {
  modalName: string;
  screenName: string;
  inPageSource: string;
  isModalFullscreen: boolean;
  userAction?: string;
  variant?: string;
}

export const trackModalImpression = ({
  modalName,
  screenName,
  inPageSource,
  isModalFullscreen,
  userAction,
  variant,
}: TrackModalImpression): void => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_modal_impression/jsonschema/1-0-0',
    data: {
      event_name: 'pca_modal_impression',
      modal_name: modalName,
      screen_name: screenName,
      in_page_source: inPageSource,
      modal_is_fullscreen: isModalFullscreen,
      user_action: userAction ?? null,
      variant: variant ?? null,
    },
  });
  trackEvent(event);
};
